// const transactionTypes = require('../../config.js').configs.transactionTypes

export const data = new Object({
    101:{
        reportTitle:"Item Ledger",
        itemLabel:"Item",
        openDialog:true,
        headerRow: {"mergeTransactionNumber":"Number","transactionDate":"Date","transactionListId":"Invoice Type","party":"Party","mrp":"MRP","inward":"Inward","secondaryUnitPackQuantityInward":"Inward (Per Pack)","outward":"Outward","secondaryUnitPackQuantityOutward":"Outward (Per Pack)","packing":"Pack Qty","balance":"Balance", "closingSecondaryUnitPackQuantity":"Balance (Pack)"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date","type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"MRP","type":"number"},{"headerName":"Inward", "type":"number"},{"headerName":"Inward (Per Pack)", "type":"string"},{"headerName":"Outward","type":"number"},{"headerName":"Outward (Per Pack)", "type":"string"},{"headerName":"Pack Qty","type":"string"},{"headerName":"Balance", "type":"number"},{"headerName":"Balance (Pack)", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'mrp', 'inward', 'secondaryUnitPackQuantityInward', 'outward', 'secondaryUnitPackQuantityOutward', 'packing', 'balance', 'closingSecondaryUnitPackQuantity'],
        // tileViewFooterHeaders:{"inward":"Inward","outward":"Outward","balance":"Balance"},
        tileViewFooterHeaders:{"opening":"Opening", "actualInwardValue":"Inward","actualOutwardValue":"Outward","balance":"Balance"},

        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile avatar class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party ? item.cols.party : ''}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title v-if="item.cols.mergeTransactionNumber || item.cols.transactionListId">{{item.cols.mergeTransactionNumber ?  item.cols.mergeTransactionNumber + ' | ' : ''}}{{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">

                                <v-icon class="circle_arrow_icon" v-if="index!=0 && (item.cols.inward || item.cols.outward)">
                                    {{item.cols.outward ? 'arrow_upward' : 'arrow_downward'}}
                                </v-icon>

                                <span v-if="index==0">{{item.cols.inward ? item.cols.inward : 0}} {{item.cols.unitName}}</span>
                                <span v-if="index!=0 && item.cols.inward">{{item.cols.inward}} {{item.cols.unitName}}</span>
                                <span v-if="item.cols.outward">{{item.cols.outward}} {{item.cols.unitName}}</span>

                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Balance
              <v-spacer></v-spacer>
              {{propsObj.reportData.footerRow.balance ? propsObj.reportData.footerRow.balance : 0}} {{propsObj.reportData.footerRow.unitName}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    102:{
        reportTitle:"Stock Summary",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","categoryName":"Category","brand":"Brand","mrp":"MRP","dqty":"Qty", "unitName":"Unit", "averageRate":"Rate","value":"Value", "secondaryUnitPackQuantity":"Qty (Per Pack)", "totalSecondaryUnitPackQuantity":"Total (Pack)"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Category","type":"string"},{"headerName":"Brand", "type":"string"},{"headerName":"MRP","type":"number"},{"headerName":"Qty", "type":"number"},{"headerName":"Unit","type":"string"},{"headerName":"Rate", "type":"number"},{"headerName":"Value", "type":"number"}, {"headerName":"Qty (Per Pack)", "type":"string"}, {"headerName":"Total (Pack)", "type":"string"}],
        columns:['productName', 'categoryName', 'brand', 'mrp', 'dqty', 'unitName', 'averageRate', 'value', 'secondaryUnitPackQuantity', 'totalSecondaryUnitPackQuantity'],
        tileViewFooterHeaders:{"dqty":"Qty (In Units)","value":"Value"},

        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile auto-height-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>

                            <v-list-tile-sub-title>
                                {{item.cols.dqty}} {{item.cols.unitName}} X &#8377; {{$root.numberToLocale(item.cols.averageRate)}}
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">&#8377; {{$root.numberToLocale(item.cols.value)}}</div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-layout row wrap pt-2 pb-2 pl-3 pr-3 font12>
                <v-flex xs4 sm4 md4>Total</v-flex>
                <v-flex xs8 sm8 md8 right-align>&#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}</v-flex>
            </v-layout>

            <!--<v-subheader subheader-semi-dense font16>Total Value 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>-->
        </div>`,

        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        // period:'month',
        // periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    103:{
        reportTitle:"Item Progress",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","categoryName":"Category","opening":"Opening","inward":"Inward","secondaryUnitPackQuantityInward":"Inward (Per Pack)","outward":"Outward","secondaryUnitPackQuantityOutward":"Outward (Per Pack)","unitName":"Unit","closing":"Closing", "closingSecondaryUnitPackQuantity":"Closing (Pack)"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Category","type":"string"},{"headerName":"Opening", "type":"string"},{"headerName":"Inward","type":"number"},{"headerName":"Inward (Per Pack)", "type":"string"},{"headerName":"Outward","type":"number"},{"headerName":"Outward (Per Pack)", "type":"string"},{"headerName":"Unit","type":"string"},{"headerName":"Closing", "type":"number"},{"headerName":"Closing (Pack)", "type":"string"}],
        columns:['productName', 'categoryName', 'opening', 'inward', 'secondaryUnitPackQuantityInward', 'outward', 'secondaryUnitPackQuantityOutward', 'unitName', 'closing', 'closingSecondaryUnitPackQuantity'],
        tileViewFooterHeaders:{"opening":"Opening", "inward":"Inward","outward":"Outward","closing":"Closing"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">Opening: {{item.cols.opening ? item.cols.opening : '0'}} {{item.cols.unitName}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>
                                <template v-if="item.cols.inward">
                                    <v-icon class="greencolor circle_arrow_icon">arrow_downward</v-icon> {{item.cols.inward}} {{item.cols.unitName}}
                                </template>
                                <template v-if="item.cols.outward">
                                    <v-icon class="redcolor circle_arrow_icon ml-2">arrow_upward</v-icon> {{item.cols.outward}} {{item.cols.unitName}}
                                </template>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                {{item.cols.closing ? item.cols.closing : 0}} {{item.cols.unitName}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>

            </v-list>

        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    104:{
        reportTitle:"Itemwise Profit & Loss",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","profitLossAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Amount","type":"number"}],
        columns:['productName', 'profitLossAmount'],
        tileViewFooterHeaders:{"profitLossAmount":"Total", "productAmount":"Net Profit/Loss"},
        tileContent:`<div>

            <v-list nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_profitLossDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <span class="redcolor" v-if="item.cols.profitLossAmount < 0">&#8377; {{$root.numberToLocale(item.cols.profitLossAmount)}}</span>
                            <span v-else>&#8377; {{$root.numberToLocale(item.cols.profitLossAmount)}}</span>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>

            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total<v-spacer></v-spacer>
              <span :class="{'redcolor':propsObj.reportData.footerRow.profitLossAmount < 0}">&#8377; {{propsObj.reportData.footerRow.profitLossAmount ? $root.numberToLocale(propsObj.reportData.footerRow.profitLossAmount) : 0}}</span>
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'alltime',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    105:{
        reportTitle:"Itemwise Batch Report",
        itemLabel:null,
        openDialog:false,
        // headerRow: {"party":"Party","taxValue":"Value"},
        headerRow: {"productName":"Product", "batchNumber":"Batch Number", "quantity":"Quantity", "primaryUnit":"Unit", "batchSize":"Size","mfgDate":"Mfg Date","expDate":"Exp Date","batchMRP":"MRP","purchaseRate":"Purchase Rate","opening":"Opening","field1":"Serial Number","field2":"IMEI Number","field3":"Part Number","field4":"Model Number"},
        headerRowTableHeaders: [{"headerName":"Product", "type":"string"},{"headerName":"Batch Number", "type":"string"},{"headerName":"Quantity", "type":"number"},{"headerName":"Unit", "type":"string"},{"headerName":"Size", "type":"string"},{"headerName":"Mfg Date", "type":"date"},{"headerName":"Exp Date", "type":"date"},{"headerName":"MRP", "type":"number"},{"headerName":"Purchase Rate", "type":"number"},{"headerName":"Opening", "type":"number"},{"headerName":"Serial Number", "type":"string"},{"headerName":"IMEI Number", "type":"string"},{"headerName":"Part Number", "type":"string"},{"headerName":"Model Number", "type":"string"}],
        columns:['productName', 'batchNumber', 'quantity', 'primaryUnit', 'batchSize', 'mfgDate', 'expDate', 'batchMRP', 'purchaseRate', 'opening', 'field1', 'field2', 'field3', 'field4'],
        // tileViewFooterHeaders:{"taxValue":"Value"},
        tileContent:`<div>

             <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">

                <v-subheader class="white-background subheader-semi-dense" v-if="item.cols.isGroup">{{item.cols.productName}}</v-subheader>
                <template v-else>
                    <v-layout row wrap class="batch_layout" pl-3 pr-3 pb-2 pt-2 white-background @click="fn_getDetails(item)">
                    
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.batchNumber">
                            <div light-opacity-color>Batch No.</div>
                            <div>{{ item.cols.batchNumber }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.opening">
                            <div light-opacity-color>Opening</div>
                            <div>{{ item.cols.opening ? item.cols.opening : 0  }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.quantity">
                            <div light-opacity-color>Quantity</div>
                            <div>{{ item.cols.quantity }} {{item.cols.primaryUnit}}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.batchSize">
                            <div light-opacity-color>Size</div>
                            <div>{{ item.cols.batchSize }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.batchMRP">
                            <div light-opacity-color>MRP</div>
                            <div>{{ item.cols.batchMRP }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.mfgDate">
                            <div light-opacity-color>Mfg. Date</div>
                            <div v-if="item.cols.mfgDate">{{ item.cols.mfgDate | moment($root.batchDateFormat) }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.expDate">
                            <div light-opacity-color>Exp. Date</div>
                            <div v-if="item.cols.expDate">{{ item.cols.expDate | moment($root.batchDateFormat) }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.purchaseRate">
                            <div light-opacity-color>Purchase Rate</div>
                            <div>{{ item.cols.purchaseRate }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.field1">
                            <div light-opacity-color>Serial Number</div>
                            <div>{{ item.cols.field1 }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.field2">
                            <div light-opacity-color>IMEI Number</div>
                            <div>{{ item.cols.field2 }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.field3">
                            <div light-opacity-color>Part Number</div>
                            <div>{{ item.cols.field3 }}</div>
                        </v-flex>
                        <v-flex xs3 sm3 md3 mb-2 v-if="item.cols.field4">
                            <div light-opacity-color>Model Number</div>
                            <div>{{ item.cols.field4 }}</div>
                        </v-flex>
                    </v-layout>
                </template>

                <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
            </div>

        </div>`,

        // footerContent:`<div>
        //     <v-subheader subheader-semi-dense font16>Total 
        //       <v-spacer></v-spacer>
        //       {{$root.numberToLocale(propsObj.reportData.footerRow.qty)}}
        //     </v-subheader>
        // </div>`,
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters: null,
    },

    106:{
        reportTitle:"Batch Detail Report",
        itemLabel:"Product/Batch",
        openDialog:false,
        headerRow: {"transactionListId":"Voucher","mergeTransactionNumber":"Number","transactionDate":"Date","inward":"Inward","outward":"Outward","primaryUnit":"Unit","balance":"Balance"},
        headerRowTableHeaders: [{"headerName":"Voucher", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Inward", "type":"number"},{"headerName":"Outward", "type":"number"},{"headerName":"Unit", "type":"string"},{"headerName":"Balance", "type":"number"}],
        columns:['transactionListId', 'mergeTransactionNumber', 'transactionDate', 'inward', 'outward', 'primaryUnit', 'balance'],
        tileViewFooterHeaders:{"balance":"Balance"},
        tileContent:`<div>
             <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile avatar class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party ? item.cols.party : ''}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title v-if="item.cols.mergeTransactionNumber || item.cols.transactionListId">{{item.cols.mergeTransactionNumber ?  item.cols.mergeTransactionNumber + ' | ' : ''}}{{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div>

                                <v-icon class="circle_arrow_icon" v-if="index!=0 && (item.cols.inward || item.cols.outward)">
                                    {{item.cols.outward ? 'arrow_upward' : 'arrow_downward'}}
                                </v-icon>

                                <span v-if="index==0">{{item.cols.inward ? item.cols.inward : 0}} {{item.cols.primaryUnit}}</span>
                                <span v-if="index!=0 && item.cols.inward">{{item.cols.inward}} {{item.cols.primaryUnit}}</span>
                                <span v-if="item.cols.outward">{{item.cols.outward}} {{item.cols.primaryUnit}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        // footerContent:`<div>
        //     <v-subheader subheader-semi-dense font16>Balance 
        //       <v-spacer></v-spacer>
        //       {{propsObj.reportData.footerRow.balance ? propsObj.reportData.footerRow.balance : 0}} units
        //       <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
        //     </v-subheader>
        // </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Balance 
              <v-spacer></v-spacer>
                {{propsObj.reportData.footerRow.balance ? propsObj.reportData.footerRow.balance : 0}} {{propsObj.reportData.footerRow.primaryUnit}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true
    },

    108:{
        reportTitle:"Itemwise Order Pending",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","remainingQty":"Qty","primaryUnit":"Unit","amount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Qty","type":"number"},{"headerName":"Unit","type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['productName', 'remainingQty', 'primaryUnit', 'amount'],
        tileViewFooterHeaders:{"remainingQty":"Qty","primaryUnit":"Unit","amount":"Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">Qty: {{item.cols.remainingQty ? item.cols.remainingQty : '0'}} {{item.cols.primaryUnit}}</v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                &#8377; {{$root.numberToLocale(item.cols.amount)}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>

            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    109:{
        reportTitle:"Batch Exprire Report",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","batchNumber":"Batch Number","expiryDate":"Expiry Date", "expiredIn":"Days", "qty":"Qty", "primaryUnit":"Units"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Batch Number", "type":"string"},{"headerName":"Expiry Date","type":"date"},{"headerName":"Days", "type":"string"},{"headerName":"Qty", "type":"number"},{"headerName":"Units", "type":"string"}],
        columns:['productName', 'batchNumber', 'expiryDate', 'expiredIn', 'qty', 'primaryUnit'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">Batch Number: {{item.cols.batchNumber}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title class="mb-1">Expiry Date: <span :class="{'redcolor':item.cols.expiredIn <= 0}">{{item.cols.expiryDate | moment("DD-MMM-YYYY")}}</span></v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                               {{item.cols.qty}} {{item.cols.primaryUnit}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>

            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              {{propsObj.reportData.footerRow.qty}} {{propsObj.reportData.footerRow.primaryUnit}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters: null
    },

    110:{
        reportTitle:"Low Stock Report",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","lowStockQuantity":"Minimum Stock Qty","qty":"Stock Qty"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Minimum Stock Qty","type":"number"},{"headerName":"Stock Qty", "type":"number"}],
        columns:['productName', 'lowStockQuantity', 'qty'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">Qty: {{item.cols.qty}} {{item.cols.unitName}}</v-list-tile-sub-title>


                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                               Remaining {{item.cols.lowStockQuantity}} {{item.cols.unitName}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>

            </v-list>

        </div>`,
        footerContent:null,
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters: null
    },

    201:{
        reportTitle:"Ledger",
        itemLabel:"Party",
        openDialog:true,
        headerRow: {"mergeTransactionNumber":"Number","transactionDate":"Date","refNumber":"Bill No","refDate":"Bill Date","transactionListId":"Invoice Type","party":"Party","debit":"To Receive","credit":"To Pay","partyBalance":"Balance","creditDebitType":"","notes":"Notes", "referenceTransactions":"Agst Ref"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date","type":"date"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party","type":"string"},{"headerName":"To Receive","type":"number"},{"headerName":"To Pay","type":"number"},{"headerName":"Balance", "type":"number"},{"headerName":"", "type":"string"},{"headerName":"Notes", "type":"string"}, {"headerName":"Agst Ref", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'refNumber', 'refDate', 'transactionListId', 'party', 'debit', 'credit', 'partyBalance', 'creditDebitType', 'notes', 'referenceTransactions'],
        // tileViewColumns:['transactionDate', 'party', 'debit', 'credit', 'balance'],
        tileViewFooterHeaders:{"openingValue":"Opening", "openingCreditDebitType":"-", "actualDebitValue":"To Receive", "actualCreditValue":"To Pay", "partyBalance":"Balance"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title v-if="item.cols.mergeTransactionNumber || item.cols.transactionListId">{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div>
                                <span>
                                    <v-icon class="greencolor circle_arrow_icon" v-if="item.cols.debit">arrow_downward</v-icon>
                                    <v-icon class="redcolor circle_arrow_icon" v-else>arrow_upward</v-icon>
                                </span>
                                <span class="light-opacity-color">
                                    &#8377; {{item.cols.debit ? $root.numberToLocale(item.cols.debit) : item.cols.credit ? $root.numberToLocale(item.cols.credit) : 0}}
                                </span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Balance 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.partyBalance)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        detailReportId:2011,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    202:{
        reportTitle:"Day Book",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionListId":"Invoice Type","transactionDate":"Date","mergeTransactionNumber":"Number","party":"Party","amount":"Amount","notes":"Notes"},
        headerRowTableHeaders: [{"headerName":"Voucher", "type":"string"},{"headerName":"Date","type":"date"},{"headerName":"Number", "type":"string"},{"headerName":"Party","type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Notes","type":"string"}],
        columns:['transactionListId', 'transactionDate', 'mergeTransactionNumber', 'party', 'amount', 'notes'],
        tileViewFooterHeaders:{"amount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber ? item.cols.mergeTransactionNumber + ' | ' : ''}}{{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.amount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'currentDate',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    203:{
        reportTitle:"Collection Summary",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","mergeTransactionNumber":"Number","transactionListId":"Invoice Type","party":"Party","type":"Type","accountName":"Account Name","amount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Date","type":"date"},{"headerName":"Number", "type":"string"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party","type":"string"},{"headerName":"Type","type":"string"},{"headerName":"Account Name", "type":"string"},{"headerName":"Amount","type":"number"}],
        columns:['transactionDate', 'mergeTransactionNumber', 'transactionListId', 'party', 'type', 'accountName', 'amount'],
        tileViewFooterHeaders:{"amount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                &#8377; {{$root.numberToLocale(item.cols.amount)}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    204:{
        reportTitle:"Payment Summary",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","mergeTransactionNumber":"Number","transactionListId":"Invoice Type","party":"Party","type":"Type","accountName":"Account Name","amount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Date","type":"date"},{"headerName":"Number", "type":"string"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party","type":"string"},{"headerName":"Type","type":"string"},{"headerName":"Account Name", "type":"string"},{"headerName":"Amount","type":"number"}],
        columns:['transactionDate', 'mergeTransactionNumber', 'transactionListId', 'party', 'type', 'accountName', 'amount'],
        tileViewFooterHeaders:{"amount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                &#8377; {{$root.numberToLocale(item.cols.amount)}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    205:{
        reportTitle:"Ledger Detail",
        itemLabel:"Party",
        openDialog:true,
        headerRow: {"mergeTransactionNumber":"Number","transactionDate":"Date","refNumber":"Bill No","refDate":"Bill Date","transactionListId":"Voucher","party":"Party","debit":"To Receive","credit":"To Pay","partyBalance":"Balance","creditDebitType":"","notes":"Notes","referenceTransactions":"Agst Ref"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date","type":"date"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party","type":"string"},{"headerName":"To Receive","type":"number"},{"headerName":"To Pay","type":"number"},{"headerName":"Balance", "type":"number"},{"headerName":"", "type":"string"},{"headerName":"Notes", "type":"string"},{"headerName":"Agst Ref", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'refNumber', 'refDate', 'transactionListId', 'party', 'debit', 'credit', 'partyBalance', 'creditDebitType', 'notes', 'referenceTransactions'],
        // tileViewFooterHeaders:{"debit":"Debit","credit":"Credit","balance":"Balance"},
        tileViewFooterHeaders:{"openingValue":"Opening", "openingCreditDebitType":"-", "actualDebitValue":"To Receive", "actualCreditValue":"To Pay", "partyBalance":"Balance"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title v-if="item.cols.mergeTransactionNumber || item.cols.transactionListId">{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div>
                                <span>
                                    <v-icon class="greencolor circle_arrow_icon" v-if="item.cols.debit">arrow_downward</v-icon>
                                    <v-icon class="redcolor circle_arrow_icon" v-else>arrow_upward</v-icon>
                                </span>
                                <span class="light-opacity-color">
                                    &#8377; {{item.cols.debit ? $root.numberToLocale(item.cols.debit) : item.cols.credit ? $root.numberToLocale(item.cols.credit) : 0}}
                                </span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Balance 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.partyBalance)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,
        detailReportId:2011,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    206:{
        reportTitle:"Cash Flow",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","transactionListId":"Transaction", "partyName":"Party", "debit":"Cash In","credit":"Cash Out","partyBalance":"Balance"},
        headerRowTableHeaders: [{"headerName":"Date","type":"date"},{"headerName":"Transaction", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Cash In", "type":"number"},{"headerName":"Cash Out","type":"number"},{"headerName":"Balance","type":"number"}],
        columns:['transactionDate', 'transactionListId', 'partyName', 'debit', 'credit', 'partyBalance'],
        tileViewFooterHeaders:{"partyBalance":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index" @click="fn_getDetails(item)">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.transactionListId}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>&#8377; {{item.cols.debit ? item.cols.debit + ' Cash In' : item.cols.credit ? item.cols.credit + ' Cash Out' : 0}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                &#8377; {{$root.numberToLocale(item.cols.partyBalance)}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.partyBalance)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    207:{
        reportTitle:"Godownwise sale",
        itemLabel:null,
        openDialog:false,
        headerRow: {"godownName":"Godown","transactionDate":"Date","mergeTransactionNumber":"Transaction Number","transactionListId":"Transaction Type", "partyName":"Party", "amount":"Transaction Amount","note":"Note"},
        headerRowTableHeaders: [{"headerName":"Godown","type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Transaction Number", "type":"string"},{"headerName":"Transaction Type", "type":"string"},{"headerName":"Party Name", "type":"string"},{"headerName":"Transaction Amount","type":"number"},{"headerName":"Note","type":"string"}],
        columns:['godownName', 'transactionDate', 'mergeTransactionNumber', 'transactionListId', 'partyName', 'amount', 'note'],
        tileViewFooterHeaders:{"godownName":"Total", "amount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index" @click="fn_getDetails(item)">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.godownName}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                &#8377; {{$root.numberToLocale(item.cols.amount)}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    208:{
        reportTitle:"Stock Transfer",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","mergeTransactionNumber":"Transaction Number","fromGodownName ":"From", "toGodownName":"To", "qty":"No of Item","amount":"Transfer Total", "note":"Note"},
        headerRowTableHeaders: [{"headerName":"Date","type":"date"},{"headerName":"Transaction Number", "type":"string"},{"headerName":"From", "type":"string"},{"headerName":"To", "type":"string"},{"headerName":"No of Item","type":"number"},{"headerName":"Transfer Total","type":"number"},{"headerName":"Note","type":"number"}],
        columns:['transactionDate', 'mergeTransactionNumber', 'fromGodownName', 'toGodownName', 'qty', 'amount', 'note'],
        tileViewFooterHeaders:{"amount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index" @click="fn_getDetails(item)">
                    <v-list-tile class="right-subtitle-tile" @click="fn_getDetails(item)">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.fromGodownName}} > {{item.cols.toGodownName}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}} | {{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.qty }} Units</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                &#8377; {{$root.numberToLocale(item.cols.amount)}}
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    301:{
        reportTitle:"Itemwise Sale",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","qty":"Qty","unitName":"Unit","value":"Value","category":"Category","brand":"Brand"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Qty", "type":"number"},{"headerName":"Unit","type":"string"},{"headerName":"Value", "type":"number"},{"headerName":"Category","type":"string"},{"headerName":"Brand","type":"string"}],
        columns:['productName', 'qty', 'unitName', 'value', 'category', 'brand'],
        tileViewFooterHeaders:{"qty":"Qty", "value":"Value"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.qty}} {{item.cols.unitName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.value)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-layout row wrap pt-2 pb-2 pl-3 pr-3 font12>
                <v-flex xs4 sm4 md4>Total</v-flex>
                <v-flex xs8 sm8 md8 right-align>&#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}</v-flex>
            </v-layout>

            <!--<v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>-->
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    302:{
        reportTitle:"Partywise Sale",
        itemLabel:null,
        openDialog:false,
        headerRow: {"party":"Party","taxValue":"Value"},
        headerRowTableHeaders: [{"headerName":"Party", "type":"string"},{"headerName":"Value", "type":"number"}],
        columns:['party', 'taxValue'],
        tileViewFooterHeaders:{"taxValue":"Value"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-subheader class="white-background subheader-semi-dense" v-if="item.cols.isGroup">{{item.cols.party}}</v-subheader>
                    <v-list-tile class="right-subtitle-tile" v-if="!item.cols.isGroup">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.taxValue)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.taxValue)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    303:{
        reportTitle:"Sale Tax Summary",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","mergeTransactionNumber":"Number","transactionListId":"Invoice Type","gstNumber":"GSTIN", "grossAmount":"Gross Amount", "discount":"Discount", "taxableValue":"Taxable Value", "cgst":"CGST", "stgst":"SGST/UTGST", "igst":"IGST", "cess":"Cess Amount", "otherCharges":"Other Charges", "roundedOff":"R/O", "roundedAmount":"Net Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"GSTIN", "type":"string"},{"headerName":"Gross Amount", "type":"number"},{"headerName":"Discount", "type":"number"},{"headerName":"Taxable Value", "type":"number"},{"headerName":"CGST", "type":"number"},{"headerName":"SGST/UTGST", "type":"number"},{"headerName":"IGST", "type":"number"},{"headerName":"Cess Amount", "type":"number"},{"headerName":"Other Charges", "type":"number"},{"headerName":"R/O", "type":"number"},{"headerName":"Net Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'mergeTransactionNumber', 'transactionListId', 'gstNumber', 'grossAmount', 'discount', 'taxableValue', 'cgst', 'stgst', 'igst', 'cess', 'otherCharges', 'roundedOff', 'roundedAmount'],
        tileViewFooterHeaders:{"roundedAmount":"Net Amount"},
        tileContent:`<div>
            <v-list three-line nopadding>
                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.tax)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.totalTax)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    304:{
        reportTitle:"Delivery Challan",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Number", "transactionDate":"Date","transactionListId":"Invoice Type","party":"Party","netAmount":"Amount","status":"Status"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Status", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'netAmount', 'status'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">
                                {{item.cols.mergeTransactionNumber}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                <span :style="{'background':item.cols.status == 'Open' ? 'red' : 'green'}" style="padding: 1px 6px;border-radius: 2px;color: #fff;">{{item.cols.status}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true
    },

    305:{
        reportTitle:"Sale Order",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Number", "transactionDate":"Date","transactionListId":"Invoice Type","party":"Party","netAmount":"Amount","status":"Status"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Status", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'netAmount', 'status'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>
            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">
                                {{item.cols.mergeTransactionNumber}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                <span :style="{'background':item.cols.status == 'Open' ? 'red' : 'green'}" style="padding: 1px 6px;border-radius: 2px;color: #fff;">{{item.cols.status}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true
    },

    306:{
        reportTitle:"Itemwise Stock Transfer",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","qty":"Qty (In Units)","value":"Value","category":"Category","brand":"Brand"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Qty (In Units)", "type":"number"},{"headerName":"Value", "type":"number"},{"headerName":"Category", "type":"string"},{"headerName":"Brand", "type":"string"}],
        columns:['productName', 'qty', 'value', 'category', 'brand'],
        tileViewFooterHeaders:{"productName":"Product Name", "qty":"Qty (In Units)", "value":"Value"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.qty}} units</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.value)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total Value
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    307:{
        reportTitle:"Partywise Stock Transfer",
        itemLabel:null,
        openDialog:false,
        headerRow: {"party":"Party","taxValue":"Value"},
        headerRowTableHeaders: [{"headerName":"Party", "type":"string"},{"headerName":"Value", "type":"number"}],
        columns:['party', 'taxValue'],
        tileViewFooterHeaders:{"taxValue":"Value"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.taxValue)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total Value
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.taxValue)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    308:{
        reportTitle:"Sale Register",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","invoiceType":"Invoice Type","mergeTransactionNumber":"Number","netAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'invoiceType', 'mergeTransactionNumber', 'netAmount'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    309:{
        reportTitle:"Itemwise Sale Order",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Item Name","partNumber":"Part No","orderQty":"Order Qty","currentStock":"Current Stock"},
        headerRowTableHeaders: [{"headerName":"Item Name", "type":"string"},{"headerName":"Part No", "type":"string"},{"headerName":"Order Qty", "type":"number"},{"headerName":"Current Stock", "type":"number"}],
        columns:['productName', 'partNumber', 'orderQty', 'currentStock'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                            <v-list-tile-sub-title>Order Qty: {{item.cols.orderQty}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>Stock: {{$root.numberToLocale(item.cols.currentStock)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true,
        hideFilterBtn:true
    },

    310:{
        reportTitle:"Sale Register Detail",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","invoiceType":"Invoice Type","mergeTransactionNumber":"Number","netAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'invoiceType', 'mergeTransactionNumber', 'netAmount'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    311:{
        reportTitle:"Sale Order Detail",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Number", "transactionDate":"Date","transactionListId":"Voucher","party":"Party","netAmount":"Amount","status":"Status"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Status", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'netAmount', 'status'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    312:{
        reportTitle:"Sale Tax Summary Details",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","mergeTransactionNumber":"Number","transactionListId":"Invoice Type","gstNumber":"GSTIN", "grossAmount":"Gross Amount", "discount":"Discount", "taxableValue":"Taxable Value", "cgst":"CGST", "stgst":"SGST/UTGST", "igst":"IGST", "cess":"Cess Amount", "otherCharges":"Other Charges", "roundedOff":"R/O", "roundedAmount":"Net Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"GSTIN", "type":"string"},{"headerName":"Gross Amount", "type":"number"},{"headerName":"Discount", "type":"number"},{"headerName":"Taxable Value", "type":"number"},{"headerName":"CGST", "type":"number"},{"headerName":"SGST/UTGST", "type":"number"},{"headerName":"IGST", "type":"number"},{"headerName":"Cess Amount", "type":"number"},{"headerName":"Other Charges", "type":"number"},{"headerName":"R/O", "type":"number"},{"headerName":"Net Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'mergeTransactionNumber', 'transactionListId', 'gstNumber', 'grossAmount', 'discount', 'taxableValue', 'cgst', 'stgst', 'igst', 'cess', 'otherCharges', 'roundedOff', 'roundedAmount'],
        tileViewFooterHeaders:{"roundedAmount":"Net Amount"},
        tileContent:`<div>
            <v-list three-line nopadding>
                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.tax)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.totalTax)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    401:{
        reportTitle:"Itemwise Purchase",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","qty":"Qty","unitName":"Unit","value":"Value","category":"Category","brand":"Brand"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Qty", "type":"number"},{"headerName":"Unit","type":"string"},{"headerName":"Value", "type":"number"},{"headerName":"Category","type":"string"},{"headerName":"Brand","type":"string"}],
        columns:['productName', 'qty', 'unitName', 'value', 'category', 'brand'],
        tileViewFooterHeaders:{"qty":"Qty", "value":"Value"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.qty}} {{item.cols.unitName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.value)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-layout row wrap pt-2 pb-2 pl-3 pr-3 font12>
                <v-flex xs4 sm4 md4>Total</v-flex>
                <v-flex xs8 sm8 md8 right-align>&#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}</v-flex>
            </v-layout>
            
            <!--<v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>-->
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    402:{
        reportTitle:"Partywise Purchase",
        itemLabel:null,
        openDialog:false,
        headerRow: {"party":"Party","taxValue":"Value"},
        headerRowTableHeaders: [{"headerName":"Party", "type":"string"},{"headerName":"Value", "type":"number"}],
        columns:['party', 'taxValue'],
        tileViewFooterHeaders:{"taxValue":"Value"},
        tileContent:`<div>
            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-subheader class="white-background subheader-semi-dense" v-if="item.cols.isGroup">{{item.cols.party}}</v-subheader>
                    <v-list-tile class="right-subtitle-tile" v-if="!item.cols.isGroup">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.taxValue)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.taxValue)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    403:{
        reportTitle:"Purchase Tax Summary",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","mergeTransactionNumber":"Number","refNumber":"Bill No","refDate":"Bill Date","transactionListId":"Invoice Type","gstNumber":"GSTIN", "grossAmount":"Gross Amount", "discount":"Discount", "taxableValue":"Taxable Value", "cgst":"CGST", "stgst":"SGST/UTGST", "igst":"IGST", "cess":"Cess Amount", "otherCharges":"Other Charges", "roundedOff":"R/O", "roundedAmount":"Net Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"GSTIN", "type":"string"},{"headerName":"Gross Amount", "type":"number"},{"headerName":"Discount", "type":"number"},{"headerName":"Taxable Value", "type":"number"},{"headerName":"CGST", "type":"number"},{"headerName":"SGST/UTGST", "type":"number"},{"headerName":"IGST", "type":"number"},{"headerName":"Cess Amount", "type":"number"},{"headerName":"Other Charges", "type":"number"},{"headerName":"R/O", "type":"number"},{"headerName":"Net Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'mergeTransactionNumber', 'refNumber', 'refDate', 'transactionListId', 'gstNumber', 'grossAmount', 'discount', 'taxableValue', 'cgst', 'stgst', 'igst', 'cess', 'otherCharges', 'roundedOff', 'roundedAmount'],
        tileViewFooterHeaders:{"roundedAmount":"Net Amount"},
        tileContent:`<div>
            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.tax)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total 
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.totalTax)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    404:{
        reportTitle:"Purchase Challan",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Number", "transactionDate":"Date","transactionListId":"Invoice Type","party":"Party","netAmount":"Amount","status":"Status"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Status", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'netAmount', 'status'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>
             <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">
                                {{item.cols.mergeTransactionNumber}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                <span :style="{'background':item.cols.status == 'Open' ? 'red' : 'green'}" style="padding: 1px 6px;border-radius: 2px;color: #fff;">{{item.cols.status}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true
    },

    405:{
        reportTitle:"Purchase Order",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Number", "transactionDate":"Date","transactionListId":"Invoice Type","party":"Party","netAmount":"Amount","status":"Status"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Status", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'netAmount', 'status'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>
              <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">
                                {{item.cols.mergeTransactionNumber}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}
                            </v-list-tile-sub-title>

                            <v-list-tile-sub-title>
                                <span :style="{'background':item.cols.status == 'Open' ? 'red' : 'green'}" style="padding: 1px 6px;border-radius: 2px;color: #fff;">{{item.cols.status}}</span>
                            </v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true
    },

    406:{
        reportTitle:"Expense Ledger",
        itemLabel:null,
        openDialog:false,
        headerRow: {"parentGroupName":"Main Group","accountName":"Expense Ledger","outAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Main Group", "type":"string"},{"headerName":"Expense Ledger", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['parentGroupName', 'accountName', 'outAmount'],
        tileViewFooterHeaders:{"outAmount":"Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.accountName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.parentGroupName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.outAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.outAmount)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        hideFilterBtn:true
    },

    407:{
        reportTitle:"Itemwise Stock Receive",
        itemLabel:null,
        openDialog:false,
        headerRow: {"productName":"Product Name","qty":"Qty (In Units)","value":"Value","category":"Category","brand":"Brand"},
        headerRowTableHeaders: [{"headerName":"Product Name", "type":"string"},{"headerName":"Qty (In Units)", "type":"number"},{"headerName":"Value", "type":"number"},{"headerName":"Category", "type":"string"},{"headerName":"Brand", "type":"string"}],
        columns:['productName', 'qty', 'value', 'category', 'brand'],
        tileViewFooterHeaders:{"qty":"Qty (In Units)", "value":"Value"},
        tileContent:`<div>
            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.qty}} units</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.value)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total Value
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.value)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    408:{
        reportTitle:"Partywise Stock Receive",
        itemLabel:null,
        openDialog:false,
        headerRow: {"party":"Party","taxValue":"Value"},
        headerRowTableHeaders: [{"headerName":"Party", "type":"string"},{"headerName":"Value", "type":"number"}],
        columns:['party', 'taxValue'],
        tileViewFooterHeaders:{"taxValue":"Value"},
        tileContent:`<div>
            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.taxValue)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total Value
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.taxValue)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
    },

    409:{
        reportTitle:"Purchase Register",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","invoiceType":"Invoice Type","mergeTransactionNumber":"Number", "refNumber":"Bill No", "refDate":"Bill Date", "netAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'invoiceType', 'mergeTransactionNumber', 'refNumber', 'refDate', 'netAmount'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    410:{
        reportTitle:"Expense Item",
        itemLabel:null,
        openDialog:false,
        headerRow: {"itemName":"Item Name","category":"Category","qty":"Qty","unit":"Unit","amount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Item Name", "type":"string"},{"headerName":"Category", "type":"string"},{"headerName":"Qty", "type":"number"},{"headerName":"Unit", "type":"number"},{"headerName":"Amount", "type":"number"}],
        columns:['itemName', 'category', 'qty', 'unit', 'amount'],
        tileViewFooterHeaders:{"qty":"Qty","amount":"Total"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.itemName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.qty}} {{item.cols.unit}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.amount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-layout row wrap pt-2 pb-2 pl-3 pr-3 font12>
                <v-flex xs4 sm4 md4>Total</v-flex>
                <v-flex xs8 sm8 md8 right-align>&#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}</v-flex>

                <v-flex xs4 sm4 md4 pt-2>Qty (In Units)</v-flex>
                <v-flex xs8 sm8 md8 pt-2 right-align>{{propsObj.reportData.footerRow.qty}}</v-flex>
            </v-layout>

            <!--<v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.amount)}}
            </v-subheader>-->
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true,
        hideFilterBtn:true
    },

    411:{
        reportTitle:"Transport",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transporter":"Transporter","gstNumber":"Transporter ID","mode":"Mode","lrcrrrNumber":"LR/CR/RR No","vehicleNumber":"Vehicle No","transactionType":"Transaction Type","transactionListId":"Type","transactionDate":"Document Date","mergeTransactionNumber":"Document No.","wayBillNumber":"E-Way Bill No","wayBillDate":"E-Way Bill Date","documentType":"Document Type","subType":"Sub Type","distance":"Distance (in KM)","roundedAmount":"Document Value"},
        headerRowTableHeaders: [{"headerName":"Transporter", "type":"string"},{"headerName":"Transporter ID", "type":"string"},{"headerName":"Mode", "type":"string"},{"headerName":"LR/CR/RR No", "type":"string"},{"headerName":"Vehicle No", "type":"string"},{"headerName":"Transaction Type", "type":"string"},{"headerName":"Type", "type":"string"},{"headerName":"Document Date", "type":"date"},{"headerName":"Document No.", "type":"string"},{"headerName":"E-Way Bill No", "type":"string"},{"headerName":"E-Way Bill Date", "type":"date"},{"headerName":"Document Type", "type":"string"},{"headerName":"Sub Type", "type":"string"},{"headerName":"Distance (in KM)", "type":"string"},{"headerName":"Document Value", "type":"number"}],
        columns:['transporter', 'gstNumber', 'mode', 'lrcrrrNumber', 'vehicleNumber', 'transactionType', 'transactionListId', 'transactionDate', 'mergeTransactionNumber', 'wayBillNumber', 'wayBillDate','documentType', 'subType','distance', 'roundedAmount'],
        tileViewFooterHeaders:null,
        tileContent:null,
        footerContent:null,
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        openView:true,
        hideFilterBtn:false
    },

    412:{
        reportTitle:"Expense Category",
        itemLabel:null,
        openDialog:false,
        headerRow: {"parentGroupName":"Main Group","expenseCategoryName":"Expense Category","outAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Main Group", "type":"string"},{"headerName":"Expense Category", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['parentGroupName', 'expenseCategoryName', 'outAmount'],
        tileViewFooterHeaders:{"outAmount":"Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.expenseCategoryName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.parentGroupName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.outAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.outAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        hideFilterBtn:true
    },

    413:{
        reportTitle:"Expense Payment",
        itemLabel:null,
        openDialog:false,
        headerRow: {"parentGroupName":"Main Group","accountName":"Payment Ledger","outAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Main Group", "type":"string"},{"headerName":"Payment Ledger", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['parentGroupName', 'accountName', 'outAmount'],
        tileViewFooterHeaders:{"outAmount":"Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.accountName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.parentGroupName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.outAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.outAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        hideFilterBtn:true
    },

    414:{
        reportTitle:"Partywise Expense",
        itemLabel:null,
        openDialog:false,
        headerRow: {"parentGroupName":"Main Group","accountName":"Account Ledger","outAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Main Group", "type":"string"},{"headerName":"Account Ledger", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['parentGroupName', 'accountName', 'outAmount'],
        tileViewFooterHeaders:{"outAmount":"Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.accountName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.parentGroupName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.outAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.outAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        hideFilterBtn:true
    },

    415:{
        reportTitle:"Salesmen Report",
        itemLabel:null,
        openDialog:false,
        headerRow: {"accountLedgerName":"Name","roundedAmount":"Sale Amount","percentage":"Sale Percent","returnAmount":"Return Amount"},
        headerRowTableHeaders: [{"headerName":"Name", "type":"string"},{"headerName":"Sale Amount", "type":"number"},{"headerName":"Sale Percent (%)", "type":"number"}, {"headerName":"Return Amount", "type":"number"}],
        columns:['accountLedgerName', 'roundedAmount', 'percentage', 'returnAmount'],
        tileViewFooterHeaders:{"roundedAmount":"Total Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.accountLedgerName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.percentage}}% Sale</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.roundedAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.roundedAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        hideFilterBtn:false
    },

    416:{
        reportTitle:"Broker Report",
        itemLabel:null,
        openDialog:false,
        headerRow: {"accountLedgerName":"Name","roundedAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Name", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['accountLedgerName', 'roundedAmount'],
        tileViewFooterHeaders:{"roundedAmount":"Total Amount"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.accountLedgerName}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.roundedAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,
        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.roundedAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters:null,
        hideFilterBtn:false
    },

    417:{
        reportTitle:"Itemwise Purchase Order",
        itemLabel:null,
        openDialog:false,
        headerRow: {"purchaseOrderNumber":"PO No","purchaseOrderDate":"PO Date","vendorName":"Vendor","productName":"Item Name", "partNumber":"Part No", "purchaseOrderQty":"PO Qty","receivedQty":"Received Qty", "remainingQty":"Balance Qty"},
        headerRowTableHeaders: [{"headerName":"PO No", "type":"string"},{"headerName":"PO Date", "type":"date"},{"headerName":"Vendor", "type":"string"},{"headerName":"Item Name", "type":"string"},{"headerName":"Part No", "type":"string"},{"headerName":"PO Qty", "type":"number"},{"headerName":"Received Qty", "type":"number"},{"headerName":"Balance Qty", "type":"number"}],
        columns:['purchaseOrderNumber', 'purchaseOrderDate', 'vendorName', 'productName', 'partNumber', 'purchaseOrderQty', 'receivedQty', 'remainingQty'],
        tileViewFooterHeaders:{"netAmount":"Total"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.productName}}</v-list-tile-title>
                            <v-list-tile-sub-title class="mb-1">{{item.cols.purchaseOrderNumber}} | {{item.cols.purchaseOrderDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>PO Qty: {{item.cols.purchaseOrderQty}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>Balance: {{$root.numberToLocale(item.cols.remainingQty)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true,
        hideFilterBtn:true
    },

    418:{
        reportTitle:"Purchase Order Detail",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Number", "transactionDate":"Date","transactionListId":"Voucher","party":"Party","netAmount":"Amount","status":"Status"},
        headerRowTableHeaders: [{"headerName":"Number", "type":"string"},{"headerName":"Date", "type":"date"},{"headerName":"Voucher", "type":"string"},{"headerName":"Party", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Status", "type":"string"}],
        columns:['mergeTransactionNumber', 'transactionDate', 'transactionListId', 'party', 'netAmount', 'status'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    419:{
        reportTitle:"Purchase Tax Summary Details",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","mergeTransactionNumber":"Number","refNumber":"Bill No","refDate":"Bill Date","transactionListId":"Invoice Type","gstNumber":"GSTIN", "grossAmount":"Gross Amount", "discount":"Discount", "taxableValue":"Taxable Value", "cgst":"CGST", "stgst":"SGST/UTGST", "igst":"IGST", "cess":"Cess Amount", "otherCharges":"Other Charges", "roundedOff":"R/O", "roundedAmount":"Net Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"GSTIN", "type":"string"},{"headerName":"Gross Amount", "type":"number"},{"headerName":"Discount", "type":"number"},{"headerName":"Taxable Value", "type":"number"},{"headerName":"CGST", "type":"number"},{"headerName":"SGST/UTGST", "type":"number"},{"headerName":"IGST", "type":"number"},{"headerName":"Cess Amount", "type":"number"},{"headerName":"Other Charges", "type":"number"},{"headerName":"R/O", "type":"number"},{"headerName":"Net Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'mergeTransactionNumber', 'refNumber', 'refDate', 'transactionListId', 'gstNumber', 'grossAmount', 'discount', 'taxableValue', 'cgst', 'stgst', 'igst', 'cess', 'otherCharges', 'roundedOff', 'roundedAmount'],
        tileViewFooterHeaders:{"roundedAmount":"Net Amount"},
        tileContent:`<div>
            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>

                            <v-list-tile-sub-title class="mb-1">{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>

                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionListId}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.tax)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.totalTax)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    420:{
        reportTitle:"Purchase Register Details",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","invoiceType":"Invoice Type","mergeTransactionNumber":"Number", "refNumber":"Bill No", "refDate":"Bill Date", "netAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'invoiceType', 'mergeTransactionNumber', 'refNumber', 'refDate', 'netAmount'],
        tileViewFooterHeaders:{"netAmount":"Amount"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>{{item.cols.mergeTransactionNumber}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.netAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.netAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true
    },

    501:{
        reportTitle:"Outstandings Receivables",
        itemLabel:"Party",
        openDialog:true,
        headerRow: {"mergeTransactionNumber":"Number","transactionListId":"Invoice Type","transactionDate":"Date","outStandingAmount":"Amount"},
        columns:['mergeTransactionNumber', 'transactionListId', 'transactionDate', 'outStandingAmount'],
        tileViewFooterHeaders:{"total":"Total", "onAccount":"On Account", "outStandingAmount":"Outstanding Receivables"},
        tileContent:`<div>

            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">
                                <span v-if="item.cols.mergeTransactionNumber">{{item.cols.mergeTransactionNumber}} |</span>
                                {{item.cols.transactionListId}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.outStandingAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Outstanding Receivables
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.summaryRows[2].transactionListId)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        footerColumns:['mergeTransactionNumber', 'transactionListId'],
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters: null,
        openView:true
    },

    502:{
        reportTitle:"Outstandings Payables",
        itemLabel:"Party",
        openDialog:true,
        headerRow: {"mergeTransactionNumber":"Number","transactionListId":"Invoice Type","transactionDate":"Date","outStandingAmount":"Amount"},
        columns:['mergeTransactionNumber', 'transactionListId', 'transactionDate', 'outStandingAmount'],
        tileViewFooterHeaders:{"total":"Total", "onAccount":"On Account", "outStandingAmount":"Outstanding Receivables"},
        tileContent:`<div>
            <v-list two-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">
                                <span v-if="item.cols.mergeTransactionNumber">{{item.cols.mergeTransactionNumber}} |</span>
                                {{item.cols.transactionListId}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.outStandingAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Outstanding Payables
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.summaryRows[2].transactionListId)}}
              <v-icon>{{!$parent.$parent.tileViewTotalSheet ? 'arrow_drop_up' : 'arrow_drop_down'}}</v-icon>
            </v-subheader>
        </div>`,

        footerColumns:['mergeTransactionNumber', 'transactionListId'],
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters: null,
        openView:true
    },

    503:{
        reportTitle:"Partywise Outstanding",
        itemLabel:null,
        openDialog:false,
        headerRow: {"party":"Party","primaryMobileNumber":"Phone","partyBalance":"Balance", "balanceType":""},
        headerRowTableHeaders: [{"headerName":"Party", "type":"string"},{"headerName":"Phone", "type":"string"},{"headerName":"Balance", "type":"number"},{"headerName":"", "type":"string"}],
        columns:['party', 'primaryMobileNumber', 'partyBalance', 'balanceType'],
        // tileViewFooterHeaders:{"taxValue":"Value"},
        tileViewFooterHeaders:{"totalPayableAmount":"Total Payables","totalReceivableAmount":"Total Receivables"},
        tileContent:`<div>

            <v-list nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-subheader class="white-background subheader-semi-dense" v-if="item.cols.isGroup">{{item.cols.party}}</v-subheader>
                    <v-list-tile class="right-subtitle-tile" v-if="!item.cols.isGroup">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action style="min-width:120px">
                            <span :class="[item.cols.balanceType == 'To Pay' ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(Math.abs(item.cols.partyBalance))}}</span>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>

        </div>`,

        footerColumns:null,
        detailReportId:null,
        footerContent:`<div>
            <v-layout row wrap pt-2 pb-2 pl-3 pr-3 font12>
                <v-flex xs4 sm4 md4>Total</v-flex>
                <v-flex xs8 sm8 md8 right-align>&#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.partyBalance)}}</v-flex>
            </v-layout>
        </div>`,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters: null,
        openView:true
    },

    504:{
        reportTitle:"Invoice reconciliation Report",
        itemLabel:null,
        openDialog:false,
        headerRow: {"party":"Party","udyamNumber":"Udyam Number", "totalBillAmount":"Total Amount", "totalBillAmountReceived":"Bill Agst Amount", "pendingAmount":"Pending Amount", "dueDays":"Due Days"},
        headerRowTableHeaders: [{"headerName":"Party", "type":"string"},{"headerName":"Udyam Number", "type":"string"},{"headerName":"Total Amount", "type":"number"}, {"headerName":"Bill Agst Amount", "type":"number"}, {"headerName":"Pending Amount", "type":"number"}, {"headerName":"Due Days", "type":"string"}],
        columns:['party', 'udyamNumber', 'totalBillAmount', 'totalBillAmountReceived', 'pendingAmount', 'dueDays'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

           <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-subheader class="white-background subheader-semi-dense" v-if="item.cols.isGroup">{{item.cols.party}}</v-subheader>
                    <v-list-tile class="right-subtitle-tile" v-if="!item.cols.isGroup">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.party}}</v-list-tile-title>
                            <v-list-tile-sub-title class="mb-1">Udyam No.: {{item.cols.udyamNumber}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title class="mb-1">Total Amt: {{$root.numberToLocale(item.cols.totalBillAmount)}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end style="min-width:120px">
                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>
                            <span :class="[item.cols.balanceType == 'To Pay' ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(item.cols.pendingAmount)}}</span>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.outAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters:null,
        hideFilterBtn:false
    },

    505:{
        reportTitle:"Invoice reconciliation Report",
        itemLabel:"Party",
        openDialog:false,
        headerRow: {"udyamNumber":"Udyam Number", "transactionDate":"Transaction Date", "transactionListId":"Type", "mergeTransactionNumber":"Transaction Number", "amount":"Transaction Amount", "billAmountReceived":"Bill Agst Amount", "pendingAmount":"Pending Amount", "Due":"dueStatus", "dueDate":"Due Date", "dueDays":"Due Days"},
        headerRowTableHeaders: [{"headerName":"Udyam Number", "type":"string"},{"headerName":"Transaction Date", "type":"date"}, {"headerName":"Type", "type":"string"}, {"headerName":"Transaction Number", "type":"string"}, {"headerName":"Transaction Amount", "type":"number"}, {"headerName":"Bill Agst Amount", "type":"number"},{"headerName":"Pending Amount", "type":"number"},{"headerName":"Due", "type":"string"},{"headerName":"Due Date", "type":"date"},{"headerName":"Due Days", "type":"string"}],
        columns:['udyamNumber', 'transactionDate', 'transactionListId', 'mergeTransactionNumber', 'amount', 'billAmountReceived', 'pendingAmount', 'dueStatus', 'dueDate', 'dueDays'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

           <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index" @click="fn_getDetails(item)">
                    <v-subheader class="white-background subheader-semi-dense" v-if="item.cols.isGroup">{{item.cols.party}}</v-subheader>
                    <v-list-tile class="right-subtitle-tile" v-if="!item.cols.isGroup">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.udyamNumber}}</v-list-tile-title>
                            <v-list-tile-sub-title class="mb-1">{{item.cols.mergeTransactionNumber}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title class="mb-1">Due in {{item.cols.dueDays}} days</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end style="min-width:120px">
                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>
                            <span :class="[item.cols.balanceType == 'To Pay' ? 'redcolor' : 'greencolor']">&#8377; {{$root.numberToLocale(item.cols.pendingAmount)}}</span>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:null,
        detailReportId:null,
        period:'endDate',
        periodLabel:'As On',
        reportType:'general',
        filters:null,
        hideFilterBtn:false,
        openView:true,
    },

    601:{
        reportTitle:"Trial Balance",
        itemLabel:null,
        openDialog:false,
        headerRow: {"accountName":"Particulars","debitAmount":"Debit","creditAmount":"Credit"},
        headerRowTableHeaders: [{"headerName":"Particulars", "type":"string"},{"headerName":"Debit", "type":"number"},{"headerName":"Credit", "type":"number"}],
        columns:['accountName', 'debitAmount', 'creditAmount'],
        tileViewFooterHeaders:{"debitAmount":"Debit", "creditAmount":"Credit"},
        tileContent:null,
        // footerColumns:['col1', 'col2', 'col3'],
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        hideFilterBtn:true
    },

    602:{
        reportTitle:"Profit and Loss",
        itemLabel:null,
        openDialog:false,
        headerRow: {"purchaseAccountName":"Particulars","purchaseAmount":"Amount","saleAccountName":"Particulars","saleAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Particulars", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Particulars", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['purchaseAccountName', 'purchaseAmount', 'saleAccountName', 'saleAmount'],
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        hideFilterBtn:true
    },

    603:{
        reportTitle:"Balance Sheet",
        itemLabel:null,
        openDialog:false,
        headerRow: {"liabilityAccountName":"Liabilities","liabilityAmount":"Amount","assetAccountName":"Assets","assetAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Liabilities", "type":"string"},{"headerName":"Amount", "type":"number"},{"headerName":"Assets", "type":"string"},{"headerName":"Amount", "type":"number"}],
        columns:['liabilityAccountName', 'liabilityAmount', 'assetAccountName', 'assetAmount'],
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        hideFilterBtn:true
    },

    604:{
        reportTitle:"Invoicewise Profit and Loss",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date", "partyName":"Party Name","transactionListId":"Transaction Type", "mergeTransactionNumber":"Transaction Number","roundedAmount":"Transaction Value", "taxableValue":"Sale Amount","transactionCost":"Transaction Cost", "profitLossAmount":"Net Profit/Loss", "profitLossStatus":"Profit/Loss"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party Name", "type":"string"},{"headerName":"Transaction Type", "type":"string"},{"headerName":"Transaction Number", "type":"string"},{"headerName":"Transaction Value", "type":"number"}, {"headerName":"Sale Amount", "type":"number"}, {"headerName":"Transaction Cost", "type":"number"}, {"headerName":"Net Profit/Loss", "type":"number"}, {"headerName":"Profit/Loss", "type":"string"}],
        columns:['transactionDate', 'partyName', 'transactionListId', 'mergeTransactionNumber', 'roundedAmount', 'taxableValue', 'transactionCost', 'profitLossAmount', 'profitLossStatus'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">
                                <template>{{item.cols.partyName}}</template>
                            </v-list-tile-title> 
                            <v-list-tile-sub-title>{{item.cols.transactionListId}} | {{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title class="mb-1">{{item.cols.mergeTransactionNumber}} | {{$root.numberToLocale(item.cols.roundedAmount)}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.profitLossAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Net Profit/Loss
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.profitLossAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        hideFilterBtn:false,
        openView:true
    },

    605:{
        reportTitle:"Partywise Profit and Loss",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date", "partyName":"Party Name","taxableValue":"Sale Amount", "profitLossAmount":"Net Profit/Loss"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party Name", "type":"string"},{"headerName":"Sale Amount", "type":"number"}, {"headerName":"Net Profit/Loss", "type":"number"}],
        columns:['transactionDate', 'partyName', 'taxableValue', 'profitLossAmount'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">
                                <template>{{item.cols.partyName}}</template>
                            </v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title class="mb-1">{{$root.numberToLocale(item.cols.roundedAmount)}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.profitLossAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Net Profit/Loss
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.profitLossAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        hideFilterBtn:false
    },

    606:{
        reportTitle:"Prescriber Report",
        itemLabel:null,
        openDialog:false,
        headerRow: {"mergeTransactionNumber":"Invoice No.", "prescriberName":"Prescriber","partyName":"Patient", "productName":"Drugs", "qty":"QTY", "unitName":"Unit", "batchNumber":"Batch#", "expiryDate":"Exp Date", "roundedAmount":"Amount"},
        headerRowTableHeaders: [{"headerName":"Invoice No.", "type":"string"},{"headerName":"Prescriber", "type":"string"},{"headerName":"Patient", "type":"string"}, {"headerName":"Drugs", "type":"string"}, {"headerName":"QTY", "type":"number"}, {"headerName":"Unit", "type":"string"}, {"headerName":"Batch#", "type":"string"}, {"headerName":"Exp Date", "type":"date"}, {"headerName":"Amount", "type":"number"}],
        columns:['mergeTransactionNumber', 'prescriberName', 'partyName', 'productName', 'qty', 'unitName', 'batchNumber', 'expiryDate', 'roundedAmount'],
        tileViewFooterHeaders:null,
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile auto-height-tile" @click="fn_getDetails(item)">

                        <v-list-tile-content>
                            <v-list-tile-title class="mb-1">{{item.cols.prescriberName}}</v-list-tile-title>
                            <v-list-tile-sub-title v-if="item.cols.partyName">Patient Name: {{item.cols.partyName}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-if="item.cols.productName">{{item.cols.productName}} - {{item.cols.qty}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-if="item.cols.expiryDate">Exp Date: {{item.cols.expiryDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>
                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.roundedAmount)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.roundedAmount)}}
            </v-subheader>
        </div>`,
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true,
        hideFilterBtn:false
    },

    701:{
        reportTitle:"Partywise TDS",
        itemLabel:null,
        openDialog:false,
        headerRow: {"transactionDate":"Date","party":"Party","mergeTransactionNumber":"Number","refNumber":"Bill No","refDate":"Bill Date","transactionListId":"Invoice Type","gstNumber":"GSTIN", "grossAmount":"Gross Amount", "discount":"Discount", "taxableValue":"Taxable Value", "cgst":"CGST", "stgst":"SGST/UTGST", "igst":"IGST", "cess":"Cess Amount", "otherCharges":"Other Charges", "roundedOff":"R/O", "roundedAmount":"Net Amount"},
        headerRowTableHeaders: [{"headerName":"Date", "type":"date"},{"headerName":"Party", "type":"string"},{"headerName":"Number", "type":"string"},{"headerName":"Bill No", "type":"string"},{"headerName":"Bill Date", "type":"date"},{"headerName":"Invoice Type", "type":"string"},{"headerName":"GSTIN", "type":"string"},{"headerName":"Gross Amount", "type":"number"},{"headerName":"Discount", "type":"number"},{"headerName":"Taxable Value", "type":"number"},{"headerName":"CGST", "type":"number"},{"headerName":"SGST/UTGST", "type":"number"},{"headerName":"IGST", "type":"number"},{"headerName":"Cess Amount", "type":"number"},{"headerName":"Other Charges", "type":"number"},{"headerName":"R/O", "type":"number"},{"headerName":"Net Amount", "type":"number"}],
        columns:['transactionDate', 'party', 'mergeTransactionNumber', 'refNumber', 'refDate', 'transactionListId', 'gstNumber', 'grossAmount', 'discount', 'taxableValue', 'cgst', 'stgst', 'igst', 'cess', 'otherCharges', 'roundedOff', 'roundedAmount'],
        tileViewFooterHeaders:{"tds":"TDS"},
        tileContent:`<div>

            <v-list three-line nopadding>

                <div v-for="(item, index) in propsObj.reportData.detailRows" :key="index">
                    <v-list-tile class="right-subtitle-tile">

                        <v-list-tile-content @click="fn_getDetails(item)">
                            <v-list-tile-title class="mb-1">{{item.cols.partyName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{item.cols.transactionDate | moment("DD-MMM-YYYY")}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title class="mb-1">{{item.cols.mergeTransactionNumber}} | {{item.cols.tdsAccountName}}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action align-flex-end>

                            <v-btn icon flat @click="fn_expandMore(item)">
                                <v-icon>more_horiz</v-icon>
                            </v-btn>

                            <div class="light-opacity-color">
                                <span>&#8377; {{$root.numberToLocale(item.cols.tds)}}</span>
                            </div>
                        </v-list-tile-action>
                    </v-list-tile>

                    <v-divider v-if="propsObj.reportData.detailRows.length-1 != index"></v-divider>
                </div>
            </v-list>
        </div>`,

        footerContent:`<div>
            <v-subheader subheader-semi-dense font16>Total
              <v-spacer></v-spacer>
              &#8377; {{$root.numberToLocale(propsObj.reportData.footerRow.tds)}}
            </v-subheader>
        </div>`,

        detailReportId:null,
        period:'month',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        openView:true,
        hideFilterBtn:true
    },

    901:{
        reportTitle:"Group Summary",
        itemLabel:null,
        openDialog:false,
        headerRow: {"accountName":"Particulars", "openingValue":"Opening", "openingType":"", "debit":"Debit", "credit":"Credit", "partyBalance":"Balance", "balanceType":""},
        headerRowTableHeaders: [{"headerName":"Particulars", "type":"string"},{"headerName":"Opening", "type":"number"},{"headerName":"", "type":"string"},{"headerName":"Debit", "type":"number"},{"headerName":"Credit", "type":"number"},{"headerName":"Balance", "type":"number"},{"headerName":"", "type":"string"}],
        columns:['accountName', 'openingValue', 'openingType', 'debit', 'credit', 'partyBalance', 'balanceType'],
        detailReportId:null,
        period:'year',
        periodLabel:'Period',
        reportType:'general',
        filters: null,
        hideFilterBtn:false
    },

    //Ledger a/c report item/transaction details
    2011:{
        reportTitle:"Details",
        headerRow: {"party":"Party","debit":"To Receive","credit":"To Pay"},
        columns:['party', 'debit', 'credit']
    },

    fn_getData: function(reportId){
        for(let key in data){
            if(key == reportId){
                return data[key]
            }
        }
    },

    // filters:[
    //     {"label":"Party", "id":null, "value":null, "ref":"ref_fieldParty", "dialogName":"accounts", "reportIds":[101, 202, 203, 301, 303, 304, 305, 308, 401, 403, 404, 405, 409]},
    //     {"label":"Item", "id":null, "value":null, "ref":"ref_fieldItem", "dialogName":"product"},
    //     {"label":"Category", "id":null, "value":null, "ref":"ref_fieldCategory", "dialogName":"productCategories", "reportIds":[102, 103, 301, 401]},
    //     {"label":"Brand", "id":null, "value":null, "ref":"ref_fieldBrand", "dialogName":"listItems", "reportIds":[102, 103, 301, 401]},
    //     {"label":"Transaction Form", "id":null, "value":null, "ref":"ref_fieldTransactionForm", "dialogName":"transactionTypeForm", "reportIds":[201, 202, 303, 403]},
    //     // {"label":"Tax Type", "id":null, "value":null, "ref":"ref_fieldTaxType", "dialogName":"accounts", "reportIds":[303, 403]},
    //     {"label":"Account Group", "id":null, "value":null, "ref":"ref_fieldAccountGroup", "dialogName":"accountgroups", "reportIds":[302, 402]},
    // ]

    filters:[
        {"label":"Party", "id":null, "value":null, "ref":"ref_fieldParty", "dialogName":"accounts", "reportIds":[101, 202, 203, 204, 207, 303, 304, 305, 308, 310, 311, 312, 401, 403, 404, 405, 409, 418, 419, 420, 604, 605, 411, 108, 606]},
        {"label":"Parties", "id":null, "value":null, "ref":"ref_fieldParties", "dialogName":"accounts", "multipleSelection":true, "reportIds":[301]},
        {"label":"Item", "id":null, "value":null, "ref":"ref_fieldItem", "dialogName":"product", "reportIds":[104, 105, 108, 109, 606]},
        {"label":"Category", "id":null, "value":null, "ref":"ref_fieldCategory", "dialogName":"productCategories", "reportIds":[102, 103, 104, 105, 301, 401]},
        {"label":"Brand", "id":null, "value":null, "ref":"ref_fieldBrand", "dialogName":"listItems", "reportIds":[102, 103, 104, 105, 301, 401]},
        {"label":"Transaction Form", "id":null, "value":null, "ref":"ref_fieldTransactionForm", "dialogName":"transactionTypeForm", "reportIds":[201, 202, 303, 312, 403, 419]},
        // {"label":"Tax Type", "id":null, "value":null, "ref":"ref_fieldTaxType", "dialogName":"accounts", "reportIds":[303, 403]},
        {"label":"Account Group", "id":null, "value":null, "ref":"ref_fieldAccountGroup", "dialogName":"accountgroups", "reportIds":[302, 402]},
        {"label":"Prescriber", "id":null, "value":null, "ref":"ref_fieldPrescriber", "dialogName":"listItems", "reportIds":[606]},
        {"label":"Sales Man", "id":null, "value":null, "ref":"ref_fieldSalesman", "dialogName":"accounts", "reportIds":[301, 302, 303, 308, 310, 312, 415]},
        {"label":"Broker", "id":null, "value":null, "ref":"ref_fieldBroker", "dialogName":"accounts", "reportIds":[301, 302, 303, 308, 310, 312, 401, 402, 403, 416, 419]},
        {"label":"Godown", "id":null, "value":null, "ref":"ref_fieldGodown", "dialogName":"godown", "reportIds":[101, 102, 103, 105, 106, 207, 208, 301, 302, 303, 308, 309, 312, 401, 402, 403, 409, 419, 420]}
    ]
    // filters:[
    //     {"label":"Party", "id":null, "value":null, "ref":"ref_fieldParty", "dialogName":"AccountDialog", "reportIds":[101, 202, 203, 301, 303, 304, 305, 308, 401, 403, 404, 405, 409]},
    //     {"label":"Item", "id":null, "value":null, "ref":"ref_fieldItem", "dialogName":"ProductDialog"},
    //     {"label":"Category", "id":null, "value":null, "ref":"ref_fieldCategory", "dialogName":"ProductCategoryDialog", "reportIds":[102, 103, 301, 401]},
    //     {"label":"Brand", "id":null, "value":null, "ref":"ref_fieldBrand", "dialogName":"ListItemDialog", "reportIds":[102, 103, 301, 401]},
    //     {"label":"Transaction Form", "id":null, "value":null, "ref":"ref_fieldTransactionForm", "dialogName":"transactionTypeForm", "reportIds":[201, 202, 303, 403]},
    //     // {"label":"Tax Type", "id":null, "value":null, "ref":"ref_fieldTaxType", "dialogName":"AccountDialog", "reportIds":[303, 403]},
    //     {"label":"Account Group", "id":null, "value":null, "ref":"ref_fieldAccountGroup", "dialogName":"AccountGroupDialog", "reportIds":[302, 402]},
    // ]
    
})


// WEBPACK FOOTER //
// ./src/components/newreports/data_config/data_unregistered.js